import React from "react";

const Disclaimer = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Disclaimer</h1>

      <p className="mb-6">
        The information provided by Paingoriya & Associates is for general
        informational purposes only.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        No Professional Liability
      </h2>
      <p className="mb-4">
        We do not guarantee accuracy or completeness of any information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        External Links
      </h2>
      <p className="mb-4">
        We are not responsible for external website content.
      </p>
    </div>
  );
};

export default Disclaimer;
